import React, { useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { useI18n } from "../../lib/i18n";
import { ArrowIcon } from "../common/Section";

const ContactForm = () => {
  const { t, lang } = useI18n();
  const [state, setState] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);

  const change = (k) => (e) => setState((s) => ({ ...s, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/public/contact", { ...state, lang });
      toast.success(t("common.submitted"));
      setState({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : Array.isArray(detail) ? detail.map((d) => d.msg).join(", ") : err.message;
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border-b border-black/15 focus:border-brand-navy focus:outline-none py-4 text-brand-dark placeholder-brand-medium transition-colors";

  return (
    <form onSubmit={submit} className="w-full max-w-2xl" data-testid="contact-form">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        <input
          required
          className={inputCls}
          placeholder={t("forms.name")}
          value={state.name}
          onChange={change("name")}
          data-testid="contact-input-name"
        />
        <input
          required
          type="email"
          className={inputCls}
          placeholder={t("forms.email")}
          value={state.email}
          onChange={change("email")}
          data-testid="contact-input-email"
        />
        <input
          className={inputCls}
          placeholder={t("forms.phone")}
          value={state.phone}
          onChange={change("phone")}
          data-testid="contact-input-phone"
        />
        <input
          className={inputCls}
          placeholder={t("forms.subject")}
          value={state.subject}
          onChange={change("subject")}
          data-testid="contact-input-subject"
        />
      </div>
      <textarea
        required
        rows={4}
        className={`${inputCls} mt-8 resize-none`}
        placeholder={t("forms.message")}
        value={state.message}
        onChange={change("message")}
        data-testid="contact-input-message"
      />
      <button
        type="submit"
        disabled={busy}
        className="btn-primary mt-10 disabled:opacity-60"
        data-testid="contact-submit-btn"
      >
        <span>{busy ? t("common.loading") : t("common.send")}</span>
        <ArrowIcon />
      </button>
    </form>
  );
};

export default ContactForm;
